import type { FormStructure, PageOrientation } from '../model/form.types';

// The structure is JSON read back from the database: a matrix saved before the orientation existed
// has no metadata at all, and anything other than 'landscape' must still render as the portrait
// sheet every screen drew until then.
export function pageOrientation(structure: Pick<FormStructure, 'metadata'> | null | undefined): PageOrientation {
  return structure?.metadata?.orientation === 'landscape' ? 'landscape' : 'portrait';
}
